var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftbox"},[_c('img',{staticClass:"imgList",attrs:{"src":_vm.backImg,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }